import { getRgObjectsOfType as l, RG_TYPE as r } from "@project-rouge/rg-core";
import { getLevelCount as a } from "../../object-helpers/index3.js";
import { getLevelArea as f } from "../level-metrics/index4.js";
const p = (n) => {
  const o = [], t = l(n, r.Building), s = a(t);
  for (let e = 0; e < s; e++) {
    const i = f(t, e, [r.Roof]);
    o.push(i);
  }
  return o;
};
export {
  p as getLevelArrayRoofArea
};
//# sourceMappingURL=index16.js.map
